import { useMutation } from '@common-fe/common-fe';
import { AxiosResponse } from 'axios';

import { api } from '@/api';
import { API_URL, IConfirmSignUpRequestDto } from '@/dtos';

interface ConfirmationData {
  hashId?: string | null;
  confirmationCode?: string | null;
}

const useConfirmSignUpQuery = () => {
  const { mutateAsync, isLoading, isError } = useMutation(({ hashId, confirmationCode }: ConfirmationData) =>
    api.patch<IConfirmSignUpRequestDto, AxiosResponse<IConfirmSignUpRequestDto>, IConfirmSignUpRequestDto>(
      API_URL.SIGN_UP_CONFIRMATION,
      {
        hash_id: `${hashId || ''}`,
        confirmation_code: `${confirmationCode || ''}`,
      }
    )
  );

  return {
    confirmSignUp: mutateAsync,
    isLoading,
    isError,
  };
};

export default useConfirmSignUpQuery;
